import { useAuth } from '@/store/auth.store'
import { useOrganizationStore } from '@/store/organization.store'

export interface MentionUser {
  id: string
  name: string
  email: string
  avatarUrl?: string
  source?: 'internal' | 'external' | 'portal' | 'agent'
}

// Cache for mention users to avoid repeated API calls
export const mentionUsersCache = new Map<
  string,
  { users: MentionUser[]; timestamp: number }
>()

export function getMentionCacheKey(context?: {
  moduleType?: string
  moduleId?: string
}): string {
  return `${useOrganizationStore.getState().currentOrganization?.id}:${useAuth.getState().user?.id}:${context?.moduleType ?? 'default'}:${context?.moduleId ?? 'default'}`
}

/**
 * Clear the mention users cache (useful when org members change)
 */
export function clearMentionCache() {
  mentionUsersCache.clear()
}

/**
 * Drop the cached list for one record. Who is suggestible on a task depends on
 * the task itself — a client portal user is only offered once the task sits in
 * a group shared with them — so editing a task has to invalidate its entry,
 * otherwise the mention list stays wrong until the entry ages out.
 */
export function clearMentionCacheFor(moduleType?: string, moduleId?: string) {
  mentionUsersCache.delete(getMentionCacheKey({ moduleType, moduleId }))
}
